import { configureStore } from '@reduxjs/toolkit'

import eventTypes from './components/features/eventTypesSlice'
import stats from './components/features/statsSlice'
import sidebar from './components/features/sidebarSlice'
import apps from './components/features/appsSlice'
import workoutReducer from './components/redux/workoutSlice'
import userReducer from './components/redux/userSlice'
import onboardingReducer from './store/features/onboardingSlice'
import trainerReducer from './components/redux/trainerSlice'
import clientReducer from './components/redux/clientSlice'
import programsReducer from './components/features/programsSlice'
import exercisesReducer from './components/features/exercisesSlice'
import workoutDraftsReducer from './components/features/workoutDraftsSlice'
import publishedWorkoutsReducer from './components/features/publishedWorkoutsSlice'
import commandTypesReducer from './components/features/commandTypesSlice'
import progressionRuleTemplatesReducer from './components/features/progressionRuleTemplatesSlice'
import permissionsReducer from './components/features/permissionsSlice'
import sessionsReducer from './components/features/sessionsSlice'
import {
  listenerMiddleware,
  loadPersistedState,
} from './components/features/localStorageMiddleware'

// Load persisted state from sessionStorage
const persistedState = loadPersistedState()

export default configureStore({
  reducer: {
    eventTypes: eventTypes,
    stats: stats,
    sidebar: sidebar,
    workout: workoutReducer,
    apps: apps,
    user: userReducer,
    onboarding: onboardingReducer,
    trainer: trainerReducer,
    client: clientReducer,
    programs: programsReducer,
    exercises: exercisesReducer,
    workoutDrafts: workoutDraftsReducer,
    publishedWorkouts: publishedWorkoutsReducer,
    commandTypes: commandTypesReducer,
    progressionRuleTemplates: progressionRuleTemplatesReducer,
    permissions: permissionsReducer,
    sessions: sessionsReducer,
  },
  preloadedState: persistedState,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware().prepend(listenerMiddleware.middleware),
})
